export default __webpack_public_path__ + "static/media/graf-banner-why-revert.61c08141.svg";